import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const findAll = createAsyncThunk("masterBeasiswa/findAll",
                                        async () => {
                                            try {
                                                let token = await localStorage.getItem('auth_token');
                                                jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                                                const url = `v1/master/beasiswa`
                                                const response = await jwtAuthAxios.get(url)
                                                return response.data
                                            } catch (response) {
                                                throw response
                                            }
                                        });

export const upsertData = createAsyncThunk("masterBeasiswa/upsert",
                                           async (val) => {
                                               try {
                                                   let token = await localStorage.getItem('auth_token');
                                                   jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                                                   const url = `v1/master/beasiswa/upsert`
                                                   const response = await jwtAuthAxios.post(url, val)
                                                   return response.data
                                               } catch (response) {
                                                   throw response
                                               }
                                           });

const initialState = {
    loading: false,
    data:{},
    dataList: [],
}

const masterBeasiswaSlice = createSlice({
                                                    name: "masterBeasiswa",
                                                    initialState: initialState,
                                                    extraReducers: (builder) => {
                                                        builder
                                                            .addCase(upsertData.pending, (state) => {
                                                                state.loading = true;
                                                            })
                                                            .addCase(upsertData.fulfilled, (state, action) => {
                                                                state.data = action.payload;
                                                                state.loading = false;
                                                            })
                                                            .addCase(upsertData.rejected, (state, action) => {
                                                                state.loading = false;
                                                            })
                                                        builder
                                                            .addCase(findAll.pending, (state) => {
                                                                state.loading = true;
                                                            })
                                                            .addCase(findAll.fulfilled, (state, action) => {
                                                                state.dataList = action.payload;
                                                                state.loading = false;
                                                            })
                                                            .addCase(findAll.rejected, (state, action) => {
                                                                state.loading = false;
                                                            })

                                                        ;
                                                    }
                                                })
export const masterBeasiswaSelectors = (state) => state.masterBeasiswa;
export default masterBeasiswaSlice.reducer;